import React from "react";
import { Col } from "react-bootstrap";
import { ProjectVariable } from "../../pages/Admin/ProfessionalServices/common/types/ProjectVariable";
import { DateField, TextField } from "@components/FormsV2";
import { FormNumberFieldV2 } from "@components/FormsV2/FormNumberFieldV2";
import MultipleLineFieldV2 from "@components/FormsV2/MultipleLineFieldV2";
import DropDownField from "@components/Forms/DropDownField";

interface UserDefinedFieldProps {
  fieldDefinition: ProjectVariable;
  disabled?: boolean;
  onChange?: (ProjectVariable) => void;
  style?: object;
}

const UserDefinedField: React.FC<UserDefinedFieldProps> = ({
  fieldDefinition,
  disabled,
  onChange,
  style,
}) => {
  const variableType = fieldDefinition['variable-type'] || fieldDefinition['variable_type'];

  const selectOptions = fieldDefinition['select_options'];
  const renderSelect = selectOptions?.length !== 0;

  const renderSelectField = () => {
    const selectedKey = selectOptions.find((opt) => opt.value === fieldDefinition.value)?.key;
    const defaultKey = selectOptions.find((opt) => opt.default)?.key;

    return (
      <Col
        sm={4}
        style={style ? style : {}}
        key={`${fieldDefinition.name}-col`}
      >
        {/* @ts-ignore */}
        <DropDownField
          required={fieldDefinition.required}
          label={`${fieldDefinition.required === true ? "* " : ""}${fieldDefinition.label || ""}`}
          key={fieldDefinition.name}
          value={selectedKey || defaultKey}
          onChange={(e) => {
            if (onChange) {
              let selected = e.target.options.selectedIndex;
              onChange({...fieldDefinition, value: e.target.options[selected].accessKey});
            }
          }}
          options={selectOptions.map((option) => {
            return (
              <option accessKey={option.value} key={option.value}>
                {option.key || option.value}
              </option>
            );
          })}
          disabled={disabled}
        />
      </Col>
    )
  }

  const renderTextField = () => {
    return (
      <Col
        sm={4}
        style={style ? style : {}}
        key={`${fieldDefinition.name}-col`}
      >
        <TextField
          id={fieldDefinition.id}
          required={fieldDefinition.required}
          key={fieldDefinition.name}
          value={fieldDefinition.value}
          label={`${fieldDefinition.required === true ? "* " : ""}${fieldDefinition.label || ""}`}
          onChange={(e) => (onChange ? onChange({...fieldDefinition, value: e.target.value}) : null)}
          onBlur={(e) => (onChange ? onChange({...fieldDefinition, value: e.target.value}) : null)}
          disabled={disabled}
        />
      </Col>
    )
  }

  const renderTextArea = () => {
    return (
      <Col
        sm={12}
        style={style ? style : {}}
        key={`${fieldDefinition.name}-col`}
      >
        <MultipleLineFieldV2
          id={fieldDefinition.id}
          required={fieldDefinition.required}
          rows={3}
          key={fieldDefinition.name}
          value={fieldDefinition.value}
          label={`${fieldDefinition.required === true ? "* " : ""}${fieldDefinition.label || ""}`}
          onChange={(e) => (onChange ? onChange({...fieldDefinition, value: e.target.value }) : null)}
          onBlur={(e) => (onChange ? onChange({...fieldDefinition, value: e.target.value }) : null)}
          disabled={disabled}
        />
      </Col>
    )
  }

  const renderNumberField = () => {
    return (
      <Col
        sm={4}
        style={style ? style : {}}
        key={`${fieldDefinition.name}-col`}
      >
        <FormNumberFieldV2
          required={fieldDefinition.required}
          key={fieldDefinition.name}
          value={fieldDefinition.value}
          label={`${fieldDefinition.required === true ? "* " : ""}${fieldDefinition.label || ""}`}
          min={fieldDefinition.minimum}
          max={fieldDefinition.maximum}
          onChange={(e) => (onChange ? onChange({...fieldDefinition, value: e.target.value}) : null)}
          onBlur={(e) => (onChange ? onChange({...fieldDefinition, value: e.target.value}) : null)}
          disabled={disabled}
        />
      </Col>
    )
  }

  const renderDateField = () => {
    return (
      <Col
        sm={4}
        style={style ? style : {}}
        key={`${fieldDefinition.name}-col`}
      >
        <DateField
          required={fieldDefinition.required}
          key={fieldDefinition.name}
          value={fieldDefinition.value}
          label={`${fieldDefinition.required === true ? "* " : ""}${fieldDefinition.label || ""}`}
          onChange={(e) => (onChange ? onChange({...fieldDefinition, value: e.target.value}) : null)}
          onBlur={(e) => (onChange ? onChange({...fieldDefinition, value: e.target.value}) : null)}
          disabled={disabled}
        />

      </Col>
    )
  }

  if (renderSelect) return renderSelectField();
  if (variableType === 'text' && (fieldDefinition.maximum || 0) <= 256) return renderTextField();
  if (variableType === 'text' && (fieldDefinition.maximum || 0) > 256) return renderTextArea();
  if (variableType === 'number') return renderNumberField();
  if (variableType === 'date' && fieldDefinition.name !== 'msa_date') return renderNumberField();
}

export default UserDefinedField;
